<template>
  <div class="error-modal-overlay" v-if="visible" @click.self="close">
    <div class="error-modal-card">
      <div class="error-modal-header">
        <div class="error-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="15" y1="9" x2="9" y2="15"/>
            <line x1="9" y1="9" x2="15" y2="15"/>
          </svg>
        </div>
        <h1 class="error-title">{{ title }}</h1>
      </div>
      <div class="error-message-scroll">
        <p class="error-message">{{ message }}</p>
        <div v-if="detailMessage" class="error-details">
          <details class="error-details-details">
            <summary class="error-details-summary">
              <span class="error-details-caret" aria-hidden="true"></span>
              <span class="error-details-summary-text">{{ $t('common.errorDetails') }}</span>
            </summary>
            <pre class="error-details-pre">{{ detailMessage }}</pre>
          </details>
        </div>
      </div>
      <div class="error-actions">
        <button class="btn btn-primary btn-lg" @click="close">{{ $t('common.confirm') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorModal',
  computed: {
    visible() {
      return this.$store.state.errorModal.visible
    },
    title() {
      return this.$store.state.errorModal.title || this.$t('common.error')
    },
    message() {
      return this.$store.state.errorModal.message || ''
    },
    detailMessage() {
      return this.$store.state.errorModal.detailMessage || ''
    }
  },
  methods: {
    close() {
      this.$store.dispatch('hideErrorModal')
    }
  }
}
</script>

<style scoped>
.error-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
  box-sizing: border-box;
  animation: fadeIn 0.2s ease;
}
.error-modal-card {
  max-width: 480px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 40px 40px 28px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: var(--radius-xl);
  overflow: hidden;
  animation: slideUp 0.3s ease;
  color: #1a1a2e;
}
.error-modal-header {
  flex-shrink: 0;
}
.error-icon {
  width: 96px;
  height: 96px;
  margin: 0 auto 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 82, 82, 0.1);
  color: #ff5252;
}
.error-title {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 4px;
  line-height: 1.25;
}
.error-message-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  margin: 12px 0 20px;
  padding: 0 4px 0 0;
  max-height: calc(90vh - 220px);
}
.error-message {
  color: var(--text-secondary);
  font-size: 15px;
  line-height: 1.6;
  margin: 0;
  text-align: center;
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}
.error-details {
  margin-top: 14px;
}
.error-details-details {
  text-align: left;
}
.error-details-summary {
  cursor: pointer;
  color: var(--text-muted);
  font-weight: 600;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-size: 12px;
  width: 100%;
  padding: 10px 12px;
  background: rgba(148, 163, 184, 0.06);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
}
.error-details-summary::-webkit-details-marker { display: none; }
.error-details-summary::marker { display: none; }
.error-details-summary-text {
  flex: 0 0 auto;
  white-space: nowrap;
}
.error-details-caret {
  flex: 0 0 auto;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 6px solid var(--text-muted);
  transform: translateY(1px);
  transition: transform 0.15s ease;
}
details[open] > summary.error-details-summary .error-details-caret {
  transform: translateY(1px) rotate(180deg);
}
.error-details-pre {
  margin: 10px 0 0;
  padding: 12px 14px;
  background: rgba(5, 150, 105, 0.06);
  border: 1px solid rgba(5, 150, 105, 0.18);
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  font-size: 13px;
  line-height: 1.6;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  max-height: 180px;
  overflow: auto;
}
.error-actions {
  flex-shrink: 0;
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  padding-top: 4px;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes slideUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
